var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilePreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BDEAC462-4EB6-4F63-A309-4B6B14F5DDC1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11.1_Library_10",
    transform: "translate(-280.000000, -665.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(260.000000, 300.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(20.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 335.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#ECEDF0",
    cx: 22.5,
    cy: 22.5,
    r: 22.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "02.Icons-/-Basic-/-Solid-/-Document-/-Default",
    transform: "translate(8.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,2.33333333 L23.3333333,8.16666667 L23.3333333,22.8666667 C23.3333333,24.413064 22.0797306,25.6666667 20.5333333,25.6666667 L7.46666667,25.6666667 C5.92026937,25.6666667 4.66666667,24.413064 4.66666667,22.8666667 L4.66666667,5.13333333 C4.66666667,3.58693603 5.92026937,2.33333333 7.46666667,2.33333333 L17.5,2.33333333 Z M18.6666667,18.6666667 L9.33333333,18.6666667 L9.33333333,21 L18.6666667,21 L18.6666667,18.6666667 Z M18.6666667,15.1666667 L9.33333333,15.1666667 L9.33333333,17.5 L18.6666667,17.5 L18.6666667,15.1666667 Z M16.3333333,3.5 L16.3333333,9.33333333 L22.1666667,9.33333333 L16.3333333,3.5 Z",
    id: "Combined-Shape",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePreview);
export default __webpack_public_path__ + "static/media/FilePreview.219d757002fa7846ad0dbcb5645550c9.svg";
export { ForwardRef as ReactComponent };